export class Location {
    addr: { street: string, number: string};
    completeAddress: string;
    city: string;
    state: string;
    zipCode: string;
    country: string;


    constructor(location?: any) {
        this.addr = location?.addr ?? { street: '', number: ''};
        this.completeAddress = (this.addr.street || this.addr.number ? `${this.addr.street} ${this.addr.number}` : '').substring(0, 50);
        this.city = location?.city ?? '';
        this.state = location?.state ?? '';
        this.zipCode = location?.zipCode ?? '';
        this.country = location?.country ?? '';
    }

}